var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 16,
  rx: 2,
  fill: "white"
});
var _ref3 = /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 16,
  rx: 2,
  fill: "white"
});
var _ref4 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_244_33513)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 16,
  fill: "#E92434"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.3034 8.61468L15.2536 9.80267L15.3251 8.26417L13.7901 7.69938L15.3799 7.28744L15.4811 5.75039L16.3922 7.03429L17.9897 6.64913L16.9629 7.85457L17.849 9.15358L16.3034 8.61468Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.9167 10.9473C13.9757 12.0748 12.5072 12.8 10.8572 12.8C8.01689 12.8 5.71436 10.651 5.71436 8.00001C5.71436 5.34905 8.01689 3.20001 10.8572 3.20001C12.5072 3.20001 13.9756 3.9252 14.9167 5.05271C14.1905 4.5601 13.2775 4.26668 12.2858 4.26668C9.91885 4.26668 8.00007 5.93815 8.00007 8.00001C8.00007 10.0619 9.91885 11.7333 12.2858 11.7333C13.2775 11.7333 14.1905 11.4399 14.9167 10.9473Z",
  fill: "white"
}));
function SvgTr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_244_33513",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 16
  }, _ref3), _ref4);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTr);
export default __webpack_public_path__ + "static/media/TR.8b282270.svg";
export { ForwardRef as ReactComponent };